/* eslint-disable @typescript-eslint/no-explicit-any */
import { SPMakeOSProjectFolderStatuses } from './sp-makeos-project-folder-statuses.enum';

export interface IMaconomyJob {
  jobNumber: string;
  jobName: string;
  closed: boolean;

  transactionTimestamp: Date;
  createdDate: Date;
  changedDate: Date;

  companyName: string;
  customerLevel1Name: string;
  level1CustomerNumber: string;
  customerNumber: string;
  endCustomer: string;

  projectManagerName: string;
  employeeNumber1: string;
  spMakeFolderStatus: SPMakeOSProjectFolderStatuses;

  pathToFolderParts: string[];
}
export class MaconomyJob implements IMaconomyJob {
  jobNumber: string;
  jobName: string;
  closed: boolean;

  transactionTimestamp: Date;
  createdDate: Date;
  changedDate: Date;

  companyName: string;
  customerLevel1Name: string;
  level1CustomerNumber: string;
  customerNumber: string;
  endCustomer: string;

  projectManagerName: string;
  employeeNumber1: string;

  spMakeFolderStatus: SPMakeOSProjectFolderStatuses;

  pathToFolderParts: string[];

  constructor(data: any) {
    this.jobNumber = data.jobNumber || data.jobnumber;
    this.jobName = data.jobName || data.jobname;
    this.closed = data.closed === 'true' || data.closed === true;

    this.companyName = data.companyName || data.companyname;

    this.customerLevel1Name = data.customerLevel1Name || data.customerlevel1name;
    this.level1CustomerNumber = data.level1CustomerNumber || data.level1customernumber;
    this.customerNumber = data.customerNumber || data.customernumber;
    this.endCustomer = data.endCustomer || data.text20;
    this.projectManagerName = data.projectManagerName || data.projectmanagername;
    this.employeeNumber1 = data.employeeNumber1 || data.employeenumber1;

    const transactionTimestamp = data.transactionTimestamp || data.transactiontimestamp;
    this.transactionTimestamp = new Date(transactionTimestamp);
    const createdDate = data.createdDate || data.createddate;
    this.createdDate = new Date(createdDate);
    const changedDate = data.changeddate || data.changedDate;
    this.changedDate = new Date(changedDate);

    this.spMakeFolderStatus = typeof data.spMakeFolderStatus === 'undefined' ? SPMakeOSProjectFolderStatuses.notCreated : data.spMakeFolderStatus;
    this.pathToFolderParts = typeof data.pathToFolderParts !== 'undefined' ? data.pathToFolderParts : [];

    return this;
  }
  getMaconomyFields(): string[] {
    return Object.keys(this).map((r: string) => r.toLowerCase());
  }
}
